/*
 * Pattern rules:
 *
 * Options are seperated by a forward slash:
 * Pattern: '<mask>/<grouping_character>/<decimal_character>/<currency_code_placement>'
 * Example: #,##0.00/,/./left
 *
 * Mask:
 * - Masks must always use commas as grouping characters and dots for decimal separators
 * - # denotes optional numbers
 * - 0 denotes mandatory numbers
 *
 * The grouping and decimal characters will be automatically replaced by the ones set by
 * <grouping_character> and <decimal_character>
 */

export const CURRENCY_MAP : {
  [key: string]: string;
} = {
  USD: '#,##0.00/,/./left',
  GBP: '#,##0.00/,/./right',
  CZK: '#,##0.##/,/./right',
  DKK: '#,##0.00/./,/right',
  SEK: '#,##0.00/./,/right',
  CHF: '#,##0.00/./,/right',
  AUD: '#,##0.00/,/./right',
  CAD: '#,##0.00/,/./left',
  HUF: '#,##0.##/,/./right',
  JPY: '#,##0/,/./left',
  NOK: '#,##0.00/./,/right',
  ZAR: '#,##0.00/,/./right',
  PLN: '#,##0.00/ /,/right',
}

export const MARKET_MAP : {
  [key: string]: string;
} = {
  XX: '#,##0.00/,/./right',
  CO: '#,##0.##/,/./right',
  DE: '#,##0.00/./,/right',
  JP: '#,##0/,/./left',
  KR: '#,##0/,/./left',
  HU: '#,##0.##/,/./right',
  RU: '#,##0.##/,/./right',
  CN: '#,##0/,/./left',
  VN: '#,##0/,/./left',
  LY: '#,##0.000/,/./left',
  PT: '#,##0.00/./,/right',
  FR: '#,##0.00/./,/right',
  AT: '#,##0.00/./,/right',
  ES: '#,##0.00/./,/right',
  SI: '#,##0.00/./,/right',
  SK: '#,##0.00/./,/right',
  RO: '#,##0.00/./,/right',
  NL: '#,##0.00/./,/right',
  MC: '#,##0.00/./,/right',
  LU: '#,##0.00/./,/right',
  IT: '#,##0.00/./,/right',
  IE: '#,##0.00/./,/right',
  GR: '#,##0.00/./,/right',
  FI: '#,##0.00/./,/right',
  EE: '#,##0.00/./,/right',
  CY: '#,##0.00/./,/right',
  HR: '#,##0.00/./,/right',
  BE: '#,##0.00/./,/right',
  AD: '#,##0.00/./,/right',
  MT: '#,##0.00/./,/right',
  PL: '#,##0.00/ /,/right',
  HK: '#,##0/,/./left',
  BR: '#,##0/./,/left',
  MA: '###0.##/,/./right',
  AR: '#,##0/./,/left',
  CA: '#,##0.00/,/./left',
  US: '#,##0.00/,/./left',
  CZ: '#,##0.##/,/./right',
  KZ: '#,##0.##/,/./right',
  UA: '#,##0.##/,/./right',
  RS: '#,##0.##/,/./right',
  ID: '#,##0/,/./left', // actual exponent: 2 (sen)
  SG: '#,##0.00/,/./right',
  TN: '###0.##/,/./right',
  TH: '#,##0/,/./right', // actual exponent: 2 (saitang)
  IN: '#,##0/,/./right', // actual exponent: 2 (paisa)
  CL: '#,##0.##/./,/right',
}
